__turbopack_context__.v({
  "numberInputButton": "NumberInput-module-scss-module__0hG7xG__numberInputButton",
  "numberInputButtonCondensed": "NumberInput-module-scss-module__0hG7xG__numberInputButtonCondensed",
  "numberInputField": "NumberInput-module-scss-module__0hG7xG__numberInputField",
  "numberInputFieldCondensed": "NumberInput-module-scss-module__0hG7xG__numberInputFieldCondensed",
  "numberInputRoot": "NumberInput-module-scss-module__0hG7xG__numberInputRoot",
});
